import { Injectable } from '@angular/core';
import { ApiService } from '../../../../shared/services/api/api.service';

@Injectable({
  providedIn:'root'
})
export class RegionDistrictService {
  constructor(private readonly apiService: ApiService) {}

  getAll() {
    return this.apiService.get<any[]>('region-district');
  }

  createMultiple(data: any) {
    return this.apiService.post<any>('region-district/create-multiple', data);
  }

  delete(regionId: number | string) {
    return this.apiService.delete(`region-district/delete/${regionId}`);
  }

  updateRegionDistrict(data: {
    regionDistrictId: number;
    description: string;
  }) {
    return this.apiService.put<any>('region-district/update-description', data);
  }

  calculateRegionBetweenTwoDistricts(data: {
    fromCity: string;
    fromDistrict: string;
    toCity: string;
    toDisctrict: string;
  }) {
    return this.apiService.post<any>('region-district/calculate-region-between-districts', data);
  }
}
